import React from 'react';

import { Section, Grid } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import {
  EditGranularityProvider,
  EDIT_GRANULARITY_ALL,
} from 'scenes/CustomAudiences/EditGranularityContext';
import {
  loadAudiences,
  loadOwners,
} from 'scenes/CustomAudiences/PartnerAudiences/sources/fields';

import PartnerAudienceFieldSet from './PartnerAudiencesFieldset';
import { PARENT_AUDIENCE, PARTNER_AUDIENCES, OWNER } from './constants';
import { validationSchema } from './schemas';

const PartnerAudienceForm = withForm({
  validationSchema: validationSchema,
  enableReinitialize: true,
})(
  ({
    children,
    title,
    onClose,
    onExited,
    open,
    loading,
    editGranularity = EDIT_GRANULARITY_ALL,
  }) => {
    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        loading={loading}
        open={open}
        size={'md'}
      >
        <SidePageV2.Title title={title} />
        <EditGranularityProvider editGranularity={editGranularity}>
          <SidePageV2.NewBody>
            <Section
              title={'GG Audience'}
              isCollapsable={false}
              initialOpen={true}
            >
              <Grid spacing={3} container>
                <Grid item xs={12}>
                  <FormField.Select
                    padding={0}
                    label={'Audience'}
                    required
                    name={PARENT_AUDIENCE}
                    source={loadAudiences}
                  />
                </Grid>
                <Grid item xs={5}>
                  <FormField.Select
                    padding={0}
                    label={'Owner'}
                    name={OWNER}
                    source={loadOwners}
                  />
                </Grid>
              </Grid>
            </Section>
            <PartnerAudienceFieldSet
              name={PARTNER_AUDIENCES}
              depends={[PARENT_AUDIENCE]}
            />
          </SidePageV2.NewBody>
        </EditGranularityProvider>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default PartnerAudienceForm;
